import { Goal } from '@/core/interfaces';
import {
  AuthService,
  RouteService,
  ScreenSizeService,
} from '@/shared/services';
import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'related-links',
  templateUrl: './related-links.component.html',
  styleUrl: './related-links.component.css',
  standalone: false,
})
export class RelatedLinksComponent implements OnInit {
  @Input() links: Goal[] = [];

  screenSize: number = 0;
  private subscription: Subscription = new Subscription();
  public env = environment;
  public hoveringLink = ''; // empty string means no link is being hovered

  constructor(
    public authService: AuthService,
    private screenSizeService: ScreenSizeService,
    public routerService: RouteService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.screenSizeService.screenSize$.subscribe((size) => {
        this.screenSize = size;
      }),
    );
  }

  shouldShow() {
    if (
      this.authService.getRole() === 'pamlab' ||
      this.authService.getRole() === 'admin'
    ) {
      return true;
    }

    const permissions = this.authService
      .getUserPermissions()
      .map((perm) => perm.name);

    return (
      this.links.filter((link) => permissions.includes(link.tool_permission))
        .length >= 1
    );
  }
}
